import { ErrorInfo } from 'react'
import { toast } from 'react-toastify'

/** Declare constants that will be used to follow steps based on environment */

const { REACT_APP_ENV } = process.env
const DEFAULT_ERROR_MESSAGE = 'Something went wrong'
const isProduction = REACT_APP_ENV === 'production'

/** Error handler params */
interface IErrorHandler {
  error: Error
  stack?: ErrorInfo
  userFriendlyMessage?: string
  shouldSkipToast?: boolean
}

/** Error handler that shows a toasting notification for the given error
 * @see isProduction
 * @see toast
 * @see IErrorHandler
 */
export const handleError = async ({
  error,
  userFriendlyMessage = DEFAULT_ERROR_MESSAGE,
  shouldSkipToast,
}: IErrorHandler) => {
  if (!isProduction) {
    console.log(error)
  }

  if (!shouldSkipToast) {
    toast.error(userFriendlyMessage, {
      toastId: userFriendlyMessage,
      autoClose: false
    })
  }
}
